import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fileUrl = (storagePath) => `${API}/files/${storagePath}`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("admin_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const trackEvent = async (eventType, section = "", path = window.location.pathname) => {
    try {
        let sessionId = sessionStorage.getItem("ac_sid");
        if (!sessionId) {
            sessionId = Math.random().toString(36).slice(2) + Date.now().toString(36);
            sessionStorage.setItem("ac_sid", sessionId);
        }
        await axios.post(`${API}/analytics/track`, {
            event_type: eventType,
            section,
            path,
            referrer: document.referrer || "",
            session_id: sessionId,
        });
    } catch (_) {
        /* silent */
    }
};
